module.exports = __webpack_public_path__ + "img/banner.9cf62295.jpg";